import updateState from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-shift-discomfort/actions/updateState.ts';

export default () => ({
    state: {
        classString: '',
        heading: '',
        overall: -1,
        lowerExtremity: -1,
        handWrist: -1,
        shoulder: -1,
        lowerBack: -1,
    },
    actions: {
        updateState,
    },
});